import gql from "graphql-tag";

const RETRY_SERVER_REQUEST_MUTATION = gql`
  mutation RetryServerRequest($id: Int!) {
    retryServerRequest(id: $id) {
      id
      status
      attempts
      lastError
      nextRetryAt
    }
  }
`;

export default RETRY_SERVER_REQUEST_MUTATION;
